"use client";

import { AppPageTitle } from "@/widgets";
import MovementCollectionSection from "@/widgets/app/page/movement/MovementCollectionSection";
import MovementInvestigateSection from "@/widgets/app/page/movement/MovementInvestigateSection";
import MovementMissionSection from "@/widgets/app/page/movement/MovementMissionSection";
import MovementMobilitySection from "@/widgets/app/page/movement/MovementMobilitySection";
import { SsgoiTransition } from "@ssgoi/react";

export default function MovementPage() {
  return (
    <SsgoiTransition id="/app/pages/movement">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        {/* 메인  */}
        <MovementMissionSection />
        {/* collection app */}
        <MovementCollectionSection />
        {/* investigate */}
        <MovementInvestigateSection />
        {/* mobility data */}
        <MovementMobilitySection />
      </div>
    </SsgoiTransition>
  );
}
